<template>
  <div class="collage-carousel">
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        ref="collageItems"
        class="collage-item"
        :class="{ visible: imageVisible[index] }"
        @click="enlargeImage(index)"
      >
        <div class="image-shell">
          <img
            :src="image"
            class="collage-image"
            :alt="'Imagen ' + index"
            loading="lazy"
          />
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimado',
  setup() {
    const images = [
      require('@/assets/IMG_5008.webp')
    ]

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    const collageItems = ref([])
    const imageVisible = ref(new Array(images.length).fill(false))

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    const observeImages = () => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const index = collageItems.value.indexOf(entry.target)
            if (entry.isIntersecting && !imageVisible.value[index]) {
              imageVisible.value[index] = true
              animateIn(entry.target)
            }
          })
        },
        { threshold: 0.3 }
      )

      collageItems.value.forEach((el) => observer.observe(el))
    }

    const animateIn = (el) => {
      gsap.fromTo(
        el,
        {
          opacity: 0,
          x: -80
        },
        {
          opacity: 1,
          x: 0,
          duration: 1.2,
          ease: 'power3.out'
        }
      )
    }

    onMounted(async () => {
      await nextTick()
      collageItems.value = collageItems.value.slice(0, images.length)
      observeImages()
    })

    return {
      images,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal,
      collageItems,
      imageVisible
    }
  }
}
</script>

<style scoped>
/* ================= CONTENssEDOR ================= */
.collage-carousel {
  width: 100%;

  margin: 0;
  padding: 0;
  top:-40px;
}

.collage-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
}

/* ================= ITEM ================= */
.collage-item {
  grid-column: span 12;
  opacity: 0;
  will-change: transform, opacity;
}

/* ================= CONTENEDOR ESTABLE (CLAVE) ================= */
.image-shell {
  width: 100%;
  aspect-ratio: 3 / 4; /* 🔥 evita que la imagen se baje */
  overflow: hidden;
  background: #e4cdc2;
}

/* ================= IMAGEN ================= */
.collage-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}

.collage-image:hover {
  transform: scale(1.03);
}

/* ================= MODAL ================= */
.image-modal {
  position: fixed;
  inset: 0;
  background-color: rgba(10, 10, 10, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 14px;
  object-fit: contain;
}
</style>
